// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/membership/membership.proto" (package "base.membership", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { MembershipService } from "./membership";
import type { GetMembershipByAccountIdsAndNameResponse } from "./membership";
import type { GetMembershipByAccountIdsAndNameRequest } from "./membership";
import type { UpdateAccessAuthorizedResponse } from "./membership";
import type { UpdateAccessAuthorizedRequest } from "./membership";
import type { GetMembershipByAccessTokenResponse } from "./membership";
import type { GetMembershipByAccessTokenRequest } from "./membership";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateMembershipResponse } from "./membership";
import type { CreateMembershipRequest } from "./membership";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * 这是一个会员模块 我佛了
 *
 * @generated from protobuf service base.membership.MembershipService
 */
export interface IMembershipServiceClient {
    /**
     * 创建会员
     *
     * @generated from protobuf rpc: CreateMembership
     */
    createMembership(input: CreateMembershipRequest, options?: RpcOptions): UnaryCall<CreateMembershipRequest, CreateMembershipResponse>;
    /**
     * 个人查看会员
     *
     * @generated from protobuf rpc: GetMembershipByAccessToken
     */
    getMembershipByAccessToken(input: GetMembershipByAccessTokenRequest, options?: RpcOptions): UnaryCall<GetMembershipByAccessTokenRequest, GetMembershipByAccessTokenResponse>;
    /**
     * 修改会员访问权限
     *
     * @generated from protobuf rpc: UpdateAccessAuthorized
     */
    updateAccessAuthorized(input: UpdateAccessAuthorizedRequest, options?: RpcOptions): UnaryCall<UpdateAccessAuthorizedRequest, UpdateAccessAuthorizedResponse>;
    /**
     * 批量查看会员
     *
     * @generated from protobuf rpc: GetMembershipByAccountIdsAndName
     */
    getMembershipByAccountIdsAndName(input: GetMembershipByAccountIdsAndNameRequest, options?: RpcOptions): UnaryCall<GetMembershipByAccountIdsAndNameRequest, GetMembershipByAccountIdsAndNameResponse>;
}
/**
 * 这是一个会员模块 我佛了
 *
 * @generated from protobuf service base.membership.MembershipService
 */
export class MembershipServiceClient implements IMembershipServiceClient, ServiceInfo {
    typeName = MembershipService.typeName;
    methods = MembershipService.methods;
    options = MembershipService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * 创建会员
     *
     * @generated from protobuf rpc: CreateMembership
     */
    createMembership(input: CreateMembershipRequest, options?: RpcOptions): UnaryCall<CreateMembershipRequest, CreateMembershipResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateMembershipRequest, CreateMembershipResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 个人查看会员
     *
     * @generated from protobuf rpc: GetMembershipByAccessToken
     */
    getMembershipByAccessToken(input: GetMembershipByAccessTokenRequest, options?: RpcOptions): UnaryCall<GetMembershipByAccessTokenRequest, GetMembershipByAccessTokenResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMembershipByAccessTokenRequest, GetMembershipByAccessTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 修改会员访问权限
     *
     * @generated from protobuf rpc: UpdateAccessAuthorized
     */
    updateAccessAuthorized(input: UpdateAccessAuthorizedRequest, options?: RpcOptions): UnaryCall<UpdateAccessAuthorizedRequest, UpdateAccessAuthorizedResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAccessAuthorizedRequest, UpdateAccessAuthorizedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * 批量查看会员
     *
     * @generated from protobuf rpc: GetMembershipByAccountIdsAndName
     */
    getMembershipByAccountIdsAndName(input: GetMembershipByAccountIdsAndNameRequest, options?: RpcOptions): UnaryCall<GetMembershipByAccountIdsAndNameRequest, GetMembershipByAccountIdsAndNameResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetMembershipByAccountIdsAndNameRequest, GetMembershipByAccountIdsAndNameResponse>("unary", this._transport, method, opt, input);
    }
}
